import { useDocTitle } from 'util/hooks'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { respondToAuthChallenge } from 'util/api'
import 'css/pages/reset-password.css'
import { showToast } from 'components/toast'

export const NewPasswordRequired = () => {
	const searchParams = useMemo(() => new URLSearchParams(window.location.search), [])
	const username = searchParams.get('username') || ''
	const session = searchParams.get('session') || ''
	const navigate = useNavigate()

	const [password, setPassword] = useState<string>('')

	const onPasswordBlur = ({ target }: { target: HTMLInputElement }) => {
		const conditions = [
			/.{8,}/,
			/[0-9]+/,
			/[a-z]+/,
			/[A-Z]+/,
			/[\^$*.[\]{}()?\-"!@#%&\/\\,><':;|_~`+=]+/,
		]

		setPassword(target.value)

		if (conditions.every(pattern => target.value.match(pattern))) {
			target.setCustomValidity('')
			return
		}

		target.setCustomValidity(
			'The password must be at least 8 characters long and must use a lower case character, an upper case character, a number, and a special character.'
		)
	}

	const onConfirmPasswordBlur = ({ target }: { target: HTMLInputElement }) => {
		if (target.value === password) {
			target.setCustomValidity('')
			return
		}

		target.setCustomValidity(
			'This does not match the password entered above'
		)
	}

	const onFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault()

		if (!username || !session) {
			showToast('Missing challenge details. Please log in again.')
			navigate('/login')
			return
		}

		const response = await respondToAuthChallenge({
			challenge: 'NEW_PASSWORD_REQUIRED',
			session,
			username,
			newPassword: password,
		})

		if (response.status === 200) {
			showToast('Password set successfully', 'success')
			navigate('/dashboard')
			return
		}

		const body = await response.json().catch(() => ({}))
		const message = body?.message || 'Something went wrong. Please try again.'
		showToast(message)
	}

	useDocTitle('All for One - Set New Password')

	return (
		<section className="reset-password-container">
			<h1 className="reset-password-header">Set <span className="highlight">new password</span></h1>

			<form
				id="new-password-required-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<input className="hidden-input"></input>

				<div className="form-group">
					<input 
						type="password" 
						id="new-password" 
						name="new-password" 
						placeholder="New Password" 
						required
						onChange={({ target }) => setPassword((target as HTMLInputElement).value)}
						onBlur={onPasswordBlur}
					/>
				</div>

				<div className="form-group">
					<input 
						type="password" 
						id="confirm-password" 
						name="confirm-password" 
						placeholder="Confirm New Password" 
						required
						onBlur={onConfirmPasswordBlur}
					/>
				</div>

				<div className="form-group">
					<button type="submit" className="reset-password-btn">Set Password</button>
				</div>
			</form>
		</section>
	)
}

export default NewPasswordRequired


